import styled, { keyframes } from "styled-components"

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10000;
`

export const ModalContainer = styled.div`
    position: absolute;
    width: 320px;
    background: #F1F2F7;
    border-radius: 12px;
    border: 1px solid #E5E5E5;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    pointer-events: auto;
    user-select: none;
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: ${props => props.isDragging ? '0 8px 32px rgba(0, 0, 0, 0.25)' : '0 6px 28px rgba(0, 0, 0, 0.2)'};
    }
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: between;
    gap: 4px;
    padding: 12px 16px;
    background: #F1F2F7;
    font-size: 16px;
    font-weight: 600;
    color: #333;
`

export const HeaderContent = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
`

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 20px;
    gap: 12px;
    background: white;
    border-radius: 8px;
    margin: 0 12px 12px 12px;
`

export const IconWrapper = styled.div`
    flex-shrink: 0;
`

const ripple = keyframes`
    0% {
        transform: scale(1);
        opacity: 0.8;
    }
    50% {
        transform: scale(1.3);
        opacity: 0.4;
    }
    100% {
        transform: scale(1.6);
        opacity: 0;
    }
`

export const WhatsAppIcon = styled.div`
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #25D366;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    svg {
        width: 16px;
        height: 16px;
        color: white;
    }

    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: rgba(37, 211, 102, 0.3);
        animation: ${ripple} 1.5s ease-out infinite;
    }
`

export const CallInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`

export const CallerName = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const PhoneNumber = styled.div`
    font-size: 12px;
    color: #8e8e93;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const CallStatus = styled.div`
    font-size: 13px;
    color: #25D366;
    font-weight: 500;
    white-space: nowrap;
`

export const ActionButtons = styled.div`
    display: flex;
    gap: 10px;
    padding: 0 12px 12px 12px;
`

const BaseButton = styled.button`
    flex: 1;
    padding: 10px 16px;
    border-radius: 8px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s ease;

    svg {
        width: 16px;
        height: 16px;
    }

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(0);
    }
`

export const AcceptButton = styled(BaseButton)`
    background: #25D366;
    color: white;

    &:hover {
        background: #20c35a;
    }
`

export const DeclineButton = styled(BaseButton)`
    background: #ff3b30;
    color: white;

    &:hover {
        background: #e6342a;
    }
`
